/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiNoteType {
    GENERAL = 'GENERAL',
    ALERT = 'ALERT',
    ALL = 'ALL'
}


export function instanceOfApiNoteType(value: any): boolean {
    for (const key in ApiNoteType) {
        if (Object.prototype.hasOwnProperty.call(ApiNoteType, key)) {
            if (ApiNoteType[key as keyof typeof ApiNoteType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiNoteTypeFromJSON(json: any): ApiNoteType {
    return ApiNoteTypeFromJSONTyped(json, false);
}

export function ApiNoteTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiNoteType {
    return json as ApiNoteType;
}

export function ApiNoteTypeToJSON(value?: ApiNoteType | null): any {
    return value as any;
}

export function ApiNoteTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiNoteType {
    return value as ApiNoteType;
}

